// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../_metronic/_partials/controls";
import * as categories from "../CatalogCategories/operations";
import { ClientEditModal as CategoryModal} from "../CatalogCategories/editModal";
import * as metrics from "../CatalogMetrics/operations";
import { ClientEditModal as MetricModal} from "../CatalogMetrics/editModal";

import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import * as crud from "../CatalogClients/operations";
import { useSelector } from "react-redux";


// Validation schema
const Schema = Yup.object().shape({
  name: Yup.string()
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),
  volume: Yup.string()
    .min(1, "Minimum 1 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Volume is required"),
  metric: Yup.string().optional(),
  code: Yup.string()
    .max(50, "Maximum 50 symbols")
    .optional(),
  cost: Yup.number()
    .min(0, "0 is minimum")
    .max(1000000, "1000000 is maximum")
    .required("cost is required"),
  price: Yup.number()
    .min(1, "$1 is minimum")
    .max(1000000, "$1000000 is maximum")
    .required("SRP is required"),
  category: Yup.string().optional(),
  description: Yup.string().optional("Description is required"),
});

export function ClientEditForm({
  update,
  client: product,
  actionsLoading,
  handleClose,
}) {
  const { user } = useSelector(state => state.auth);
  const userDocument = user.uid ? user : user.payload

  const [AVAILABLE_MANUFACTURES, setAvailable] = useState([]);
  const [AVAILABLE_CATEGORIES, setCategories] = useState([]);
  const [AVAILABLE_METRICS, setMetrics] = useState([]);

  useEffect(() => {
    crud.getClient("").then(({ data }) => {
      const products = data.payload;
      setAvailable(products);
    });
    categories.getClient("").then(({ data }) => {
      setCategories(data.payload);
    });
    metrics.getClient("").then(({ data }) => {
      setMetrics(data.payload);
    });
  }, []);

  const [image, setImage] = useState(product.image || "");
  function resizedataURL(datas, wantedWidth, wantedHeight) {
    return new Promise(async function (resolve, reject) {

      // We create an image to receive the Data URI
      var img = document.createElement('img');

      // When the event "onload" is triggered we can resize the image.
      img.onload = function () {
        // We create a canvas and get its context.
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');

        // We set the dimensions at the wanted size.
        canvas.width = wantedWidth;
        canvas.height = wantedHeight;

        // We resize the image with the canvas method drawImage();
        ctx.drawImage(this, 0, 0, wantedWidth, wantedHeight);

        const dataURI = canvas.toDataURL();

        // This is the return of the Promise
        resolve(dataURI);
      };

      // We put the Data URI in the image's src attribute
      img.src = datas;

    })
  }
  function updatePhoto({ target }) {
    const [file] = target.files;
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      ({ target }) => {
        resizedataURL(target.result, 600, 600)
          .then((data) => {
            setImage(data)
          })

      },
      false
    );
    if (file) {
      reader.readAsDataURL(file);
    }
  }

  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const [showCategory, setShowCategory] = useState(false)
  const handleCategory = (document) => {
    categories.updateClient(document).then(() => {
      categories.getClient().then(({ data }) => {
        setCategories(data.payload);
        setShowCategory(false)

      });
    })
  }

  const [showMetric, setShowMetric] = useState(false)
  const handleMetric = (document) => {
    metrics.updateClient(document).then(() => {
      metrics.getClient().then(({ data }) => {
        setMetrics(data.payload);
        setShowMetric(false)

      });
    })
  }
  return (
    <>
     <MetricModal
        update={handleMetric}
        show={showMetric} 
        handleClose={() => setShowMetric(false)}
        client={{}}
        />
      <CategoryModal
        update={handleCategory}
        show={showCategory} 
        handleClose={() => setShowCategory(false)}
        client={{}}
        />
      <Formik
        enableReinitialize={true}
        initialValues={product}
        validationSchema={Schema}
        onSubmit={(values) => {
          if (!values.category_uid) {
            const [tmp] = [...AVAILABLE_CATEGORIES]
            values.category_uid = tmp.uid
          }
          if (!values.metric_uid) {
            const [tmp] = [...AVAILABLE_METRICS]
            values.metric_uid = tmp.uid
          }
          const [category_tmp] = [...AVAILABLE_CATEGORIES].filter(c => c.uid === values.category_uid)
          if (category_tmp) {
            values.category = category_tmp.name
          }

          const [metric_tmp] = [...AVAILABLE_METRICS].filter(m => m.uid === values.metric_uid)
          if (metric_tmp) {
            values.metric = metric_tmp.sufix
          }


          if (!values.manufacture) {
            const tmp = [...AVAILABLE_MANUFACTURES].shift()
            values.manufacture = tmp.name
          }
       
          const doc = { ...product, ...values, image, client:  userDocument.company_id}
          crud.updateClient(doc)
            .then(() => setSubmitting(false))
            .catch((err) => {
              setSubmitting(false)
            })
        }}
        validateOnChange={false}
        validateOnBlur={false}

      >
        {({ handleSubmit, errors, handleChange, handleBlur }) => (
          <>
            <Modal.Body className="cursor-default" size="lg">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form">
                <div className="row">
                  <div className="col-lg-3">
                    <h6>Image</h6>
                    <div className="col-lg-4 col-xl-6">
                      <div
                        className="image-input image-input-outline"
                        id="kt_profile_avatar"
                      >
                        <div
                          className="image-input-wrapper"
                          style={{
                            backgroundImage: `url(${image})`,
                          }}
                        ></div>
                        <label
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="change"
                          data-toggle="tooltip"
                          title=""
                          data-original-title="Change avatar"
                        >
                          <i className="fa fa-pen icon-sm text-muted"></i>
                          <input
                            type="file"
                            name="profile_avatar"
                            accept=".png, .jpg, .jpeg"
                            onChange={updatePhoto}
                          />
                          <input type="hidden" name="profile_avatar_remove" />
                        </label>
                        <span
                          className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                          data-action="cancel"
                          data-toggle="tooltip"
                          title="Cancel avatar"
                        >
                          <i className="ki ki-bold-close icon-xs text-muted"></i>
                        </span>
                      </div>
                      <span className="form-text text-muted">
                        Allowed file types: png, jpg, jpeg.
                    </span>
                    </div>
                  </div>
                  <div className="col-9">
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="name"
                          component={Input}
                          placeholder="Product Name"
                          label="Item Name"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
              
                      <div className="col-lg-6">
                        <Field
                          type="number"
                          name="cost"
                          component={Input}
                          placeholder="Cost"
                          label="Cost ($)"
                          customFeedbackLabel="Please enter Cost"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                       </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          type="number"
                          name="price"
                          component={Input}
                          placeholder="SRP"
                          label="SRP"
                          customFeedbackLabel="Please enter SRP"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="volume"
                          type="number"
                          component={Input}
                          placeholder="volume"
                          label="volume"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                      <div className="d-flex justify-content-between">
                          <label>Select Metric</label>
                          <a
                            style={{ marginTop: "-10px" }}
                            title="Add region"
                            className="btn btn-icon btn-light btn-hover-success btn-sm align-top"
                            onClick={() => { setShowMetric(true) }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-success">
                              <SVG
                                src={toAbsoluteUrl("/media/svg/icons/General/Size.svg")}
                              />
                            </span>
                          </a>
                        </div>
                        <Select name="metric_uid">
                          {AVAILABLE_METRICS.map((c) => (
                            <option key={c.uid} value={c.uid}>
                              {c.sufix}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-lg-6">
                        <Field
                          name="code"
                          component={Input}
                          placeholder="Internal Code / UPC"
                          label="Internal Code / UPC"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>
                      <div className="col-lg-6">
                        <div className="d-flex justify-content-between">
                          <label>Select Category</label>
                          <a
                            style={{ marginTop: "-10px" }}
                            title="Add region"
                            className="btn btn-icon btn-light btn-hover-success btn-sm align-top"
                            onClick={() => { setShowCategory(true) }}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-success">
                              <SVG
                                src={toAbsoluteUrl("/media/svg/icons/Files/Folder.svg")}
                              />
                            </span>
                          </a>
                        </div>
                        <Select name="category_uid">
                          {AVAILABLE_CATEGORIES.map((c) => (
                            <option key={c.uid} value={c.uid}>
                              {c.name}
                            </option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="form-group row">

                      <div className="col-lg-12">
                        <Field
                          name="description"
                          component={Input}
                          label="description"
                          onInput={toInputUppercase}
                          errors={errors}
                          handleChange={handleChange}
                        />
                      </div>

                    </div>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {
                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal show={props.show} onHide={props.handleClose} size="lg">
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Product" : "New Product"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Product</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Product</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
